<template>

  <!-- Event Details Block -->
  <page-block
    bg-image-contain
    :bg-file="value.file"
    :bg-color="value.bgColor"
    class="event-details-block"
    :width-class="value.widthClass"
    :class="{colorized: !!value.bgColor}"
    :text-color="value.textColor || 'white'"
    :text-align="value.textAlign || 'center'"
    :overlay-class="value.paddingClass || 'sbs-pa'">

    <titled-text-element
      no-file
      no-body
      :value="value"/>

    <div
      class="ibs-mt hide-last hide-first"/>

    <event-details-content
      :value="item"/>

  </page-block>

</template>

<script>

  import {mapState} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import TitledTextElement from '@src/components/element/titled-text-element';
  import EventDetailsContent from '@src/components/content/event-details-content';

  export default {
    name: 'event-details-block',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      TitledTextElement,
      EventDetailsContent,
    },
    computed: {
      ...mapState('vlEvents', {
        item: 'item',
      }),
    },
  };

</script>

<style lang="scss">

  .event-details-block {
    color: inherit;

    &:not(.colorized) {
      background: $brand-gradient;
    }
  }

</style>
